module.exports = __webpack_public_path__ + "img/2.765787b3.png";